import React from 'react';

import ToggleSwitch from 'components/form/ToggleSwitch.component';
import Icon from 'components/generic/Icon.component';
import ResponsiveBox from 'components/generic/ResponsiveBox.component';
import { useTranslation } from 'providers/GILT.provider';

const OPTIONS = [
  { id: 'staff_1_3', labelTranslationKey: 'staffAndBusiness.userNetwork.hardwareInformation.staffRange1_3' },
  { id: 'staff_4_6', labelTranslationKey: 'staffAndBusiness.userNetwork.hardwareInformation.staffRange4_6' },
  { id: 'staff_7_10', labelTranslationKey: 'staffAndBusiness.userNetwork.hardwareInformation.staffRange7_10' },
  { id: 'staff_11_plus', labelTranslationKey: 'staffAndBusiness.userNetwork.hardwareInformation.staffRange11Plus' },
];

const StaffToggleButtons = ({ selectedOption, setSelectedOption }) => {
  const { t } = useTranslation();

  return OPTIONS.map((option) => (
    <ToggleSwitch
      key={option.id}
      tag="UserNetwork__toggle-switch"
      selected={selectedOption === option.id}
      onClick={() => setSelectedOption(selectedOption === option.id ? null : option.id)}
      name={t(option.labelTranslationKey)}
      size="normal"
      variant="mobileOnly"
    >
      <ResponsiveBox.Desktop>
        <Icon variant="radioCheck" selected={selectedOption === option.id} width="lg" />
      </ResponsiveBox.Desktop>
    </ToggleSwitch>
  ));
};

export default StaffToggleButtons;
